import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid", "quantityAvailable"],
  _excluded2 = ["valid"],
  _excluded3 = ["valid"],
  _excluded4 = ["valid"],
  _excluded5 = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey, filterDecimalKey } from "@/js/events/keycodes.js";
import { orderStatus, STOCK_PART } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultEntityAddForm = {
  id: null,
  quantityAvailable: 0,
  purchaseUnitPriceEuroExVat: null,
  creationComment: "",
  orderId: null,
  valid: false
};
var defaultFormQty = {
  quantityAvailable: 0,
  movementReason: "",
  isChangingQuantityInit: true,
  valid: false
};
var defaultFormPurchasePrice = {
  purchaseUnitPriceEuroExVat: 0,
  valid: false
};
var defaultFormComment = {
  creationComment: "",
  valid: false
};
var defaultFormOrderOrigin = {
  fromOrderId: null,
  valid: false
};
export default {
  name: "StockPartFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null,
    stockId: Number
  },
  data: function data() {
    return {
      dialog: false,
      isAddingNewEntity: false,
      entity: null,
      gettingEntity: {
        isPending: false,
        cancellationToken: null
      },
      updatingQty: {
        isConfiguring: false,
        form: _objectSpread({}, defaultFormQty),
        isPending: false,
        cancellationToken: null
      },
      handlingPurchasePrice: {
        updating: {
          isConfiguring: false,
          form: _objectSpread({}, defaultFormPurchasePrice),
          isPending: false,
          cancellationToken: null
        },
        removing: {
          isPending: false,
          cancellationToken: null
        }
      },
      emptyingStockPart: {
        isPending: false,
        cancellationToken: null
      },
      handlingComment: {
        updating: {
          isConfiguring: false,
          form: _objectSpread({}, defaultFormComment),
          isPending: false,
          cancellationToken: null
        },
        removing: {
          isPending: false,
          cancellationToken: null
        }
      },
      definingOrderOrigin: {
        isConfiguring: false,
        form: _objectSpread({}, defaultFormOrderOrigin),
        isPending: false,
        cancellationToken: null
      },
      addingEntity: {
        form: _objectSpread({}, defaultEntityAddForm),
        compatibleOrderItems: [],
        isPending: false,
        cancellationToken: null
      },
      STOCK_PART: STOCK_PART,
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isLoading: function isLoading() {
      return this.gettingEntity.isPending;
    },
    isEditable: function isEditable() {
      return this.entity;
    },
    isEmptyable: function isEmptyable() {
      var _this$entity;
      return ((_this$entity = this.entity) === null || _this$entity === void 0 ? void 0 : _this$entity.quantityAvailable) > 0;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.updatingQty.isPending || this.emptyingStockPart.isPending || this.handlingPurchasePrice.updating.isPending || this.handlingPurchasePrice.removing.isPending || this.handlingComment.updating.isPending || this.handlingComment.removing.isPending || this.definingOrderOrigin.isPending || this.addingEntity.isPending;
    },
    isAnySubformInProgress: function isAnySubformInProgress() {
      return this.updatingQty.isConfiguring || this.handlingComment.updating.isConfiguring || this.handlingPurchasePrice.updating.isConfiguring || this.definingOrderOrigin.isConfiguring;
    }
  },
  created: function created() {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    startEditQty: function startEditQty() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2$entity$fromOrd;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.updatingQty.isConfiguring = true;
              _this2.updatingQty.form.quantityAvailable = _this2.entity.quantityAvailable;
              _this2.updatingQty.form.isChangingQuantityInit = !(((_this2$entity$fromOrd = _this2.entity.fromOrderData) === null || _this2$entity$fromOrd === void 0 ? void 0 : _this2$entity$fromOrd.id) > 0);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancelUpdatingQty: function cancelUpdatingQty() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.updatingQty.isConfiguring = false;
              _this3.updatingQty.form = _objectSpread({}, defaultFormQty);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveUpdatingQty: function saveUpdatingQty() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this4$updatingQty$ca;
        var _this, movementQuantity, _this4$updatingQty$fo, valid, quantityAvailable, withoutValid;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this4.updatingQty.isPending = true;
              (_this4$updatingQty$ca = _this4.updatingQty.cancellationToken) === null || _this4$updatingQty$ca === void 0 || _this4$updatingQty$ca.cancel();
              _this4.updatingQty.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              movementQuantity = +_this4.updatingQty.form.quantityAvailable - _this4.entity.quantityAvailable;
              _this4$updatingQty$fo = _this4.updatingQty.form, valid = _this4$updatingQty$fo.valid, quantityAvailable = _this4$updatingQty$fo.quantityAvailable, withoutValid = _objectWithoutProperties(_this4$updatingQty$fo, _excluded);
              withoutValid.movementQuantity = movementQuantity;
              _context5.next = 9;
              return request("/v1/stocks/parts/" + _this4.entity.id + "/quantity-available", "put", withoutValid, true, "api", null, _this.updatingQty.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.updatingQty.isPending = false;
                          _this.updatingQty.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the quantity", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 9:
              _context5.next = 11;
              return _this4.getEntity();
            case 11:
              _this4.updatingQty.isConfiguring = false;
              _this4.updatingQty.form = _objectSpread({}, defaultFormQty);
              _this4.updatingQty.isPending = false;
              _this4.updatingQty.cancellationToken = null;
              _this4.$emit("entityUpdated");
              _this4.$toasted.show("Quantity available updated", {
                type: "success"
              });
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    startEditPurchasePrice: function startEditPurchasePrice() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5$entity$purchas;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.handlingPurchasePrice.updating.isConfiguring = true;
              _this5.handlingPurchasePrice.updating.form.purchaseUnitPriceEuroExVat = (_this5$entity$purchas = _this5.entity.purchaseUnitPriceEuroExVat) !== null && _this5$entity$purchas !== void 0 ? _this5$entity$purchas : defaultFormPurchasePrice.purchaseUnitPriceEuroExVat;
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    cancelUpdatingPurchasePrice: function cancelUpdatingPurchasePrice() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.handlingPurchasePrice.updating.isConfiguring = false;
              _this6.handlingPurchasePrice.updating.form = _objectSpread({}, defaultFormPurchasePrice);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    saveUpdatingPurchasePrice: function saveUpdatingPurchasePrice() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this7$handlingPurcha;
        var _this, _this7$handlingPurcha2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this7.handlingPurchasePrice.updating.isPending = true;
              (_this7$handlingPurcha = _this7.handlingPurchasePrice.updating.cancellationToken) === null || _this7$handlingPurcha === void 0 || _this7$handlingPurcha.cancel();
              _this7.handlingPurchasePrice.updating.cancellationToken = axios.CancelToken.source();
              _this = _this7;
              _this7$handlingPurcha2 = _this7.handlingPurchasePrice.updating.form, valid = _this7$handlingPurcha2.valid, withoutValid = _objectWithoutProperties(_this7$handlingPurcha2, _excluded2);
              _context9.next = 7;
              return request("/v1/stocks/parts/" + _this7.entity.id + "/purchase-price", "put", withoutValid, true, "api", null, _this.handlingPurchasePrice.updating.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingPurchasePrice.updating.isPending = false;
                          _this.handlingPurchasePrice.updating.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the purchase price", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 7:
              _this7.entity.purchaseUnitPriceEuroExVat = _this7.handlingPurchasePrice.updating.form.purchaseUnitPriceEuroExVat;
              _this7.handlingPurchasePrice.updating.isConfiguring = false;
              _this7.handlingPurchasePrice.updating.form = _objectSpread({}, defaultFormPurchasePrice);
              _this7.handlingPurchasePrice.updating.isPending = false;
              _this7.handlingPurchasePrice.updating.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this7.$toasted.show("Purchase price updated", {
                type: "success"
              });
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    confirmRemovePurchasePrice: function confirmRemovePurchasePrice() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this8.$refs.confirm.open("Remove purchase price", "Are you sure to to remove purchase price ? Warning: This action cannot be undone", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(confirm) {
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!confirm) {
                          _context10.next = 3;
                          break;
                        }
                        _context10.next = 3;
                        return _this8.removePurchasePrice();
                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    removePurchasePrice: function removePurchasePrice() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this9$handlingPurcha;
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this9.handlingPurchasePrice.removing.isPending = true;
              (_this9$handlingPurcha = _this9.handlingPurchasePrice.removing.cancellationToken) === null || _this9$handlingPurcha === void 0 || _this9$handlingPurcha.cancel();
              _this9.handlingPurchasePrice.removing.cancellationToken = axios.CancelToken.source();
              _this = _this9;
              _context13.next = 6;
              return request("/v1/stocks/parts/" + _this9.entity.id + "/purchase-price", "delete", {}, true, "api", null, _this.handlingPurchasePrice.removing.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingPurchasePrice.removing.isPending = false;
                          _this.handlingPurchasePrice.removing.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to remove the purchase price.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 6:
              _this9.entity.purchaseUnitPriceEuroExVat = null;
              _this9.handlingPurchasePrice.removing.isPending = false;
              _this9.handlingPurchasePrice.removing.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this9.$toasted.show("Purchase price removed.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    confirmEmptyingPart: function confirmEmptyingPart() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this10.$refs.confirm.open("Emptying part", "Are you sure to empty this part ? Warning: This action cannot be undone", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(confirm) {
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        if (!confirm) {
                          _context14.next = 3;
                          break;
                        }
                        _context14.next = 3;
                        return _this10.emptyPart();
                      case 3:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    emptyPart: function emptyPart() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this11$emptyingStock;
        var _this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this11.emptyingStockPart.isPending = true;
              (_this11$emptyingStock = _this11.emptyingStockPart.cancellationToken) === null || _this11$emptyingStock === void 0 || _this11$emptyingStock.cancel();
              _this11.emptyingStockPart.cancellationToken = axios.CancelToken.source();
              _this = _this11;
              _context17.next = 6;
              return request("/v1/stocks/parts/" + _this11.entity.id, "delete", {}, true, "api", null, _this.emptyingStockPart.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.emptyingStockPart.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to empty this part", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 6:
              _this11.emptyingStockPart.isPending = false;
              _this11.emptyingStockPart.cancellationToken = null;
              _this11.$emit("entityUpdated");
              _this11.$toasted.show("Part emptied", {
                type: "success"
              });
              _this11.close();
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    startEditComment: function startEditComment() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this12$entity$creati;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this12.handlingComment.updating.isConfiguring = true;
              _this12.handlingComment.updating.form.creationComment = (_this12$entity$creati = _this12.entity.creationComment) !== null && _this12$entity$creati !== void 0 ? _this12$entity$creati : defaultFormComment.creationComment;
            case 2:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    cancelUpdatingComment: function cancelUpdatingComment() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this13.handlingComment.updating.isConfiguring = false;
              _this13.handlingComment.updating.form = _objectSpread({}, defaultFormComment);
            case 2:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    confirmRemoveComment: function confirmRemoveComment() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this14.$refs.confirm.open("Remove comment", "Are you sure to remove the comment ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(confirm) {
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) switch (_context20.prev = _context20.next) {
                      case 0:
                        if (!confirm) {
                          _context20.next = 3;
                          break;
                        }
                        _context20.next = 3;
                        return _this14.removeComment();
                      case 3:
                      case "end":
                        return _context20.stop();
                    }
                  }, _callee20);
                }));
                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    removeComment: function removeComment() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this15$handlingComme;
        var _this;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _this15.handlingComment.removing.isPending = true;
              (_this15$handlingComme = _this15.handlingComment.removing.cancellationToken) === null || _this15$handlingComme === void 0 || _this15$handlingComme.cancel();
              _this15.handlingComment.removing.cancellationToken = axios.CancelToken.source();
              _this = _this15;
              _context23.next = 6;
              return request("/v1/stocks/parts/" + _this15.entity.id + "/comment", "delete", {}, true, "api", null, _this.handlingComment.removing.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingComment.removing.isPending = false;
                          _this.handlingComment.removing.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to remove the comment.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee22);
                }));
                return function (_x8) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 6:
              _this15.entity.creationComment = null;
              _this15.handlingComment.removing.isPending = false;
              _this15.handlingComment.removing.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this15.$toasted.show("Comment removed.", {
                type: "success"
              });
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    saveComment: function saveComment() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this16$handlingComme;
        var _this, _this16$handlingComme2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this16.handlingComment.updating.isPending = true;
              (_this16$handlingComme = _this16.handlingComment.updating.cancellationToken) === null || _this16$handlingComme === void 0 || _this16$handlingComme.cancel();
              _this16.handlingComment.updating.cancellationToken = axios.CancelToken.source();
              _this = _this16;
              _this16$handlingComme2 = _this16.handlingComment.updating.form, valid = _this16$handlingComme2.valid, withoutValid = _objectWithoutProperties(_this16$handlingComme2, _excluded3);
              _context25.next = 7;
              return request("/v1/stocks/parts/" + _this16.entity.id + "/comment", "put", withoutValid, true, "api", null, _this.handlingComment.updating.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                    while (1) switch (_context24.prev = _context24.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingComment.updating.isPending = false;
                          _this.handlingComment.updating.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to update the comment.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context24.stop();
                    }
                  }, _callee24);
                }));
                return function (_x9) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 7:
              _this16.entity.creationComment = _this16.handlingComment.updating.form.creationComment;
              _this16.handlingComment.updating.isConfiguring = false;
              _this16.handlingComment.updating.isPending = false;
              _this16.handlingComment.updating.cancellationToken = null;

              //this.$emit("entityUpdated")
              _this16.$toasted.show("Comment updated", {
                type: "success"
              });
            case 12:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    saveNewEntity: function saveNewEntity() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this17$addingEntity$;
        var _this, _this17$addingEntity$2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _this17.addingEntity.isPending = true;
              (_this17$addingEntity$ = _this17.addingEntity.cancellationToken) === null || _this17$addingEntity$ === void 0 || _this17$addingEntity$.cancel();
              _this17.addingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this17;
              _this17$addingEntity$2 = _this17.addingEntity.form, valid = _this17$addingEntity$2.valid, withoutValid = _objectWithoutProperties(_this17$addingEntity$2, _excluded4);
              withoutValid.stockId = _this17.stockId;
              _context27.next = 8;
              return request("/v1/stocks/parts", "post", withoutValid, true, "api", null, _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                    while (1) switch (_context26.prev = _context26.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingEntity.isPending = false;
                          _this.addingEntity.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to create the new part.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context26.stop();
                    }
                  }, _callee26);
                }));
                return function (_x10) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 8:
              _this17.addingEntity.isPending = false;
              _this17.addingEntity.cancellationToken = null;
              _this17.$emit("entityCreated");
              _this17.close();
              _this17.$toasted.show("New part created", {
                type: "success"
              });
            case 13:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }))();
    },
    startDefineOrderOrigin: function startDefineOrderOrigin() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return _this18.getCompatibleOrderItems();
            case 2:
              _this18.definingOrderOrigin.isConfiguring = true;
              _this18.definingOrderOrigin.form = _objectSpread({}, defaultFormOrderOrigin);
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      }))();
    },
    cancelDefineOrderOrigin: function cancelDefineOrderOrigin() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _this19.addingEntity.compatibleOrderItems = [];
              _this19.definingOrderOrigin.isConfiguring = false;
              _this19.definingOrderOrigin.form = _objectSpread({}, defaultFormOrderOrigin);
            case 3:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      }))();
    },
    confirmDefineOrderOrigin: function confirmDefineOrderOrigin() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _this20.$refs.confirm.open("Define order origin", "Due to accounting constraints, you will no longer be able to modify this information. Please ensure that the data is correct. Are you sure you want to proceed ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30(confirm) {
                  return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                    while (1) switch (_context30.prev = _context30.next) {
                      case 0:
                        if (!confirm) {
                          _context30.next = 3;
                          break;
                        }
                        _context30.next = 3;
                        return _this20.defineOrderOrigin();
                      case 3:
                      case "end":
                        return _context30.stop();
                    }
                  }, _callee30);
                }));
                return function (_x11) {
                  return _ref11.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      }))();
    },
    defineOrderOrigin: function defineOrderOrigin() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var _this21$definingOrder;
        var _this, _this21$definingOrder2, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _this21.definingOrderOrigin.isPending = true;
              (_this21$definingOrder = _this21.definingOrderOrigin.cancellationToken) === null || _this21$definingOrder === void 0 || _this21$definingOrder.cancel();
              _this21.definingOrderOrigin.cancellationToken = axios.CancelToken.source();
              _this = _this21;
              _this21$definingOrder2 = _this21.definingOrderOrigin.form, valid = _this21$definingOrder2.valid, withoutValid = _objectWithoutProperties(_this21$definingOrder2, _excluded5);
              _context33.next = 7;
              return request("/v1/stocks/parts/" + _this21.entity.id + "/order-origin", "put", withoutValid, true, "api", null, _this.definingOrderOrigin.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                    while (1) switch (_context32.prev = _context32.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.definingOrderOrigin.isPending = false;
                          _this.definingOrderOrigin.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to define the origin of the order", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context32.stop();
                    }
                  }, _callee32);
                }));
                return function (_x12) {
                  return _ref12.apply(this, arguments);
                };
              }());
            case 7:
              _context33.next = 9;
              return _this21.getEntity();
            case 9:
              _this21.definingOrderOrigin.isConfiguring = false;
              _this21.definingOrderOrigin.form = _objectSpread({}, defaultFormPurchasePrice);
              _this21.definingOrderOrigin.isPending = false;
              _this21.definingOrderOrigin.cancellationToken = null;
              _this21.$emit("entityUpdated");
              _this21.$toasted.show("Purchase price updated", {
                type: "success"
              });
            case 15:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      }))();
    },
    getEntity: function getEntity() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var _this22$gettingEntity;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _this22.gettingEntity.isPending = true;
              (_this22$gettingEntity = _this22.gettingEntity.cancellationToken) === null || _this22$gettingEntity === void 0 || _this22$gettingEntity.cancel();
              _this22.gettingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this22;
              _context34.next = 6;
              return request("/v1/stocks/parts/".concat(_this22.id), "get", null, true, "api", null, _this.gettingEntity.cancellationToken).catch(function (e) {
                _this.gettingEntity.isPending = false;
                _this.gettingEntity.cancellationToken = null;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get stock part", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context34.sent;
              _this22.entity = _objectSpread({}, response.data.value);
              _this22.gettingEntity.isPending = false;
              _this22.gettingEntity.cancellationToken = null;
            case 10:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }))();
    },
    getCompatibleOrderItems: function getCompatibleOrderItems() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _this = _this23;
              _context35.next = 3;
              return request("/v1/orders/compatible-items?stockId=".concat(_this23.stockId), "get", null, true, "api").then(function (response) {
                _this.addingEntity.compatibleOrderItems = response.data.value.map(function (x) {
                  var _x$invoiceNumberLabel;
                  return _objectSpread(_objectSpread({}, x), {}, {
                    text: "".concat(x.quantity, " b. on ").concat((_x$invoiceNumberLabel = x.invoiceNumberLabel) !== null && _x$invoiceNumberLabel !== void 0 ? _x$invoiceNumberLabel : x.reference, " ").concat(x.isDestinationInbound ? "(inbound) " : "", ", ").concat(orderStatus.find(function (os) {
                      return os.status === x.status;
                    }).shortValue, ": ").concat(new Date(x.deliveryDate).toLocaleDateString("en-US"))
                  });
                });
                _this.addingEntity.compatibleOrderItems.sort(function (a, b) {
                  return a.isDestinationInbound ? -1 : 1;
                });
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get orders.");
                handleErrorData(_this, errorData);
              });
            case 3:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      }))();
    },
    goToPurchaseOrder: function goToPurchaseOrder(poId) {
      return {
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      };
    },
    goToOrder: function goToOrder(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    open: function open() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _this24.resetData();
              _this24.dialog = true;
              if (!(_this24.id > 0)) {
                _context36.next = 8;
                break;
              }
              _this24.isAddingNewEntity = false;
              _context36.next = 6;
              return _this24.getEntity();
            case 6:
              _context36.next = 11;
              break;
            case 8:
              _this24.isAddingNewEntity = true;
              _this24.addingEntity.form = _objectSpread({}, defaultEntityAddForm);
              _this24.getCompatibleOrderItems();
            case 11:
              return _context36.abrupt("return", new Promise(function (resolve, reject) {
                _this24.resolve = resolve;
                _this24.reject = reject;
              }));
            case 12:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.isAddingNewEntity = false;
      this.entity = null;
    },
    filterIntegerKey: filterIntegerKey,
    filterDecimalKey: filterDecimalKey
  }
};